import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MessagesCreateRequestDTO, MessagesResponseDTO } from 'src/app/data/dto/MessagesDTO';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  getMessages(name: string): Observable<MessagesResponseDTO> {
    const endpoint = environment.messages_endpoint;
    const params = new HttpParams().set('name', name);
    const httpOptions = {
      headers: this.headers,
      params,
    };
    return this.http
      .get<MessagesResponseDTO>(`${environment.url_base}/${endpoint}`, httpOptions)
      .pipe(map((result) => result));
  }

  createMessage(body: MessagesCreateRequestDTO): Observable<any> {
    const endpoint = environment.messages_endpoint;
    return this.http.post(`${environment.url_base}/${endpoint}`, body, {
      headers: this.headers,
    });
  }

  updateMessage(id: number, body: MessagesCreateRequestDTO): Observable<any> {
    const endpoint = environment.messages_endpoint;
    return this.http.put(`${environment.url_base}/${endpoint}/${id}`, body, {
      headers: this.headers,
    });
  }

  deleteMessage(id: number): Observable<any> {
    const endpoint = environment.messages_endpoint;
    return this.http.delete(`${environment.url_base}/${endpoint}/${id}`, {
      headers: this.headers,
    });
  }
}
